<template>
  <div class="row">

    <div class="col-md-12">
      <div class="card">
        <div class="card-body">

          <!-- Nav tabs -->
          <ul class="nav nav-tabs customtab" role="tablist">
            <li class="nav-item">
              <a class="nav-link" v-bind:class="{active: currentTab === 'upcoming'}" @click="currentTab = 'upcoming' ">
                <span>{{ $t("Upcoming")}}</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" v-bind:class="{active: currentTab === 'history'}" @click="currentTab = 'history'">
                <span>{{ $t("History") }}</span>
              </a>
            </li>
            <li class="nav-item filter-tab">
                Show
                <div class="btn-group dropdown-group">
                  <button class="btn btn-secondary btn-rounded dropdown-toggle dropdown-button" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{pageAmount}} results
                  </button>
                  <div class="dropdown-menu dropdown-menu-custom">
                    <span class="dropdown-item text-info" v-on:click="pageAmount = 10; refreshTables()">10 results</span>
                    <a class="dropdown-item text-info" v-on:click="pageAmount = 25; refreshTables()">25 results</a>
                    <a class="dropdown-item text-info" v-on:click="pageAmount = 50; refreshTables()">50 results</a>
                  </div>
                </div>
                <input class="btn btn-rounded btn-light table-search-input margin-top" v-model="filterValue" @keyup="updateFilter" :placeholder="$t('Search meetings')"/>
            </li>
          </ul>

          <!-- Tab panes -->
          <div class="tab-content margin-top">
            <div class="tab-pane active" v-show="currentTab === 'upcoming'">
              <div class="table-responsive m-t-20">
                <table-component :data="fetchTableData" class="meetings-table hide-filter" sort-by="date_start" sort-order="asc" ref="meetingTable" @rowClick="rowClicked">
                  <table-column :label="$t('Date')" show="date_start" :formatter="formatDate"></table-column>
                  <table-column :label="$t('Meeting')" show="name"></table-column>
                  <table-column :label="$t('Type')" show="meeting_type" :formatter="formatType" cell-class="d-none d-sm-table-cell" header-class="d-none d-sm-table-cell">
                    <template slot-scope="row">
                      {{ $t(row.meeting_type) }}
                    </template>
                  </table-column>
                  <table-column label="" :sortable="false" :filterable="false" cell-class="d-none d-sm-table-cell" header-class="d-none d-sm-table-cell">
                    <template slot-scope="row">
                      <router-link :to="'/planmeeting/' + row.uid" v-if="row.plannable === '1' && row.facilitator_uid === user_uid">
                        {{ $t("Plan") }}
                      </router-link>
                    </template>
                  </table-column>
                  <table-column label="" :sortable="false" :filterable="false" cell-class="d-none d-sm-table-cell" header-class="d-none d-sm-table-cell" >
                    <template slot-scope="row">
                      <router-link :to="'/meeting/' + row.uid">
                        {{ $t("Open") }}
                      </router-link>
                    </template>
                  </table-column>
                </table-component>
              </div>

            </div>
            <div class="tab-pane active" v-show="currentTab === 'history'">
              <div class="table-responsive m-t-20">
                <table-component :data="fetchTableHistoryData" sort-by="date_start" sort-order="desc" class="meetings-table hide-filter" ref="historyTable" @rowClick="rowClicked">

                  <table-column :label="$t('Date')" show="date_start" :formatter="formatDate"></table-column>
                  <table-column :label="$t('Meeting')" show="name"></table-column>
                  <table-column :label="$t('Type')" show="meeting_type" :formatter="formatType" cell-class="d-none d-sm-table-cell" header-class="d-none d-sm-table-cell">
                    <template slot-scope="row">
                      {{ $t(row.meeting_type) }}
                    </template>
                  </table-column>
                  <table-column label="" :sortable="false" :filterable="false" cell-class="d-none d-sm-table-cell" header-class="d-none d-sm-table-cell">
                    <template slot-scope="row">
                      <router-link :to="'/meeting/' + row.uid">
                        {{ $t("Open") }}
                      </router-link>
                    </template>
                  </table-column>
                </table-component>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import apiHelper from "../mixins/APIHelper";
  export default {
    name: "meetings",
    data: function () {
      return {
        meetings: [],
        finishedMeetings: [],
        currentTab: "upcoming",
        user_uid: localStorage.getItem('user_uid'),
        paginationSettings: {
          totalPages: 0,
          currentPage: 0
        },
        historyPaginationSettings: {
          totalPages: 0,
          currentPage: 0
        },
        filterValue: "",
        pageAmount: 10
      }
    },
    created() {
      let vm = this;
    },
    methods: {
      rowClicked: function ($event) {
        this.$router.push('/meeting/' + $event.data.uid);
      },
      async fetchTableData({page, filter, sort}) {
        let PAGE_AMOUNT = this.pageAmount;
        if (this.meetings.length < 1) {
          const response = await apiHelper.getResource("/api/user/{uid}/meetings", {history: "0"});
          this.meetings = response;
          this.paginationSettings.totalPages = Math.ceil(response.length / PAGE_AMOUNT);
          this.paginationSettings.currentPage = page;
        }
        let filteredMeetings = this.filterAndSort(this.meetings, filter, sort);

        let pageData = filteredMeetings.slice((page - 1) * PAGE_AMOUNT, page * PAGE_AMOUNT);
        let paginationData = {
          totalPages: this.paginationSettings.totalPages,
          currentPage: page
        };

        pageData = this.filterAndSort(pageData, filter, sort);
        return { data: pageData, pagination: paginationData };
      },
      async fetchTableHistoryData({page, filter, sort}) {
        let PAGE_AMOUNT = this.pageAmount;
        if (this.finishedMeetings.length < 1) {
          const response = await apiHelper.getResource("/api/user/{uid}/meetings", {history: "1"});
          this.finishedMeetings = response;
          this.historyPaginationSettings.totalPages = Math.ceil(response.length / PAGE_AMOUNT);
          this.historyPaginationSettings.currentPage = page;
        }

        let filteredHistoryMeetings = this.filterAndSort(this.finishedMeetings, filter, sort);

        let pageData = filteredHistoryMeetings.slice((page - 1) * PAGE_AMOUNT, page * PAGE_AMOUNT);

        let paginationData = {
          totalPages: this.historyPaginationSettings.totalPages,
          currentPage: page
        };
        pageData = this.filterAndSort(pageData, filter, sort);
        return { data: pageData, pagination: paginationData };
      },

      formatDate: function(value, rowProperties) {
        let date = moment(value, 'YYYY-MM-DD hh:mm:ss');
        let currentDate = moment();
        let location = rowProperties.location;
        let days_till = Math.round((date - currentDate) / (24*60*60*1000));
        let hours = String(moment(date).format("HH:mm"));

        if (location === null) {
          location = ""
        }

        if (days_till === 0) {
          date = "<B>Today</B>, " + hours;
        } else if (days_till === 1) {
          date = "<B>Tomorrow</B>, " + hours;
        } else {
          let day = String(moment(date).format("ddd DD MMM"));
          date = "<B>" + day + "</B>, " + hours;
        }

        date += "<br><small class='text-muted'>" + location + "</small>";

        return date;
      },
      formatType: function (value, rowProperties) {
        return "<small class='text-muted'>" + value + "</small>"
      },

      updateFilter: function () {
        this.$refs.historyTable.filter = this.filterValue;
        this.$refs.meetingTable.filter = this.filterValue;
      },
      filterAndSort(data, filter, sortObj){
        let output = [];
        // First filter
        for (let i = 0; i < data.length; i++) {
          let item = data[i];

          let added = false;
          for(let key in item){
            // Disregard prototype properties
            if(!item.hasOwnProperty(key)) continue;

            if(item[key] !== null && item[key].toString().toLowerCase().includes(filter.toLowerCase()) && !added){
              output.push(item);
              added = true;
            }
          }
        }

        // Then sort:
        output.sort(this.sortByProperty(sortObj.fieldName, sortObj.order));
        return output;
      },

      sortByProperty(property, direction){
        let directionCoeff = direction === "asc" ? 1 : -1;

        return function (a, b) {
          let sortA = (a[property] === null || typeof a[property] === 'undefined') ? a[property] : a[property].toLowerCase();
          let sortB = (b[property] === null || typeof b[property] === 'undefined') ? b[property] : b[property].toLowerCase();

          if(sortA < sortB) {
            return -1 * directionCoeff;
          }

          if(sortA > sortB){
            return directionCoeff;
          }
          return 0;
        }
      },
      refreshTables(){
        this.$refs.historyTable.refresh();
        this.$refs.meetingTable.refresh();
      }
    }
  }
</script>

<style scoped>
  .filter-tab{
    margin-left: auto;
    height: 60px;
    margin-bottom: 10px !important;
  }

  .filter-tab > input {
    border-color: #ddd;
    text-align: left;
    font-weight: 600;
  }

  .filter-tab > input :hover {
    color: initial !important;
    background-color: initial !important;
    border-color: initial !important;
  }

  .dropdown-button {
    background-color: #64748d;
    color: white;
  }

  .table-component__table__body > tr > td{
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 15px;
  }

  .table-component__table__body > tr > td > i{
    font-size: 20px;
  }

  .table-component__table__body > tr:nth-child(even){
    background-color: #f5f7fb;
  }

  @media screen and (max-width: 768px){
    .filter-tab{
      margin-top: 8px;
    }
    .margin-top{
      margin-top: 8px;
    }
    ul.nav-tabs{
     padding-bottom: 16px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Meetings.vue